export default class Item {
  shipmentId: string;
  shipmentStatus: string;
  assignedCarrier: string;

  constructor(
    shipmentId: string,
    shipmentStatus: string,
    assignedCarrier: string
  ) {
    this.shipmentId = shipmentId;
    this.shipmentStatus = shipmentStatus;
    this.assignedCarrier = assignedCarrier;
  }
}
